<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: zailong
 * @LastEditTime: 2024-03-19 15:24:45
-->
<template>
  <div class="container">
    <section class="leftContent">
      <section class="header">
        <div class="title">机构入驻信息</div>
        <div class="information">
          <div class="label-item">
            <span class="label">联系人：</span>
            <span>{{ user.contact || '-' }}</span>
          </div>
          <div class="label-item">
            <span class="label">联系人职务：</span>
            <span>{{ user.position || '-' }}</span>
          </div>
          <div class="label-item">
            <span class="label">手机号码：</span>
            <span>{{ user.contactTel || '-' }} </span>
          </div>
        </div>
        <div class="information">
          <div class="label-item">
            <span class="label">机构名称：</span>
            <span>{{ user.entName || '-' }}</span>
          </div>
          <div class="label-item">
            <span class="label">详细地址：</span>
            <span>{{ user.address || '-' }}</span>
          </div>
        </div>
        <div class="information">
          <div>
            <span class="label">企业类型：</span>
            <span>{{ user.entType || '-' }}</span>
          </div>
        </div>
        <div class="information service">
          <div>
            <span class="label">服务分类：</span>
            <div class="serve_item" v-if="message.organizationType == 1">
              <section
                class="service-type-box"
                v-for="(item, index) in serviceList"
                :key="index"
              >
                <div class="first-type">{{ item.name }}：</div>
                <div class="sec-type">
                  <span v-for="(el, elindex) in item.children" :key="elindex">
                    {{ el.name }}
                  </span>
                </div>
              </section>
            </div>
            <div class="serve_item" v-else>
              <section
                class="service-type-box"
                v-for="item in serviceList"
                :key="item"
              >
                <div class="first-type" style="margin-right: 10px">
                  {{ item }}
                </div>
              </section>
            </div>
          </div>
        </div>
        <div class="information">
          <div style="width: 600px">
            <span class="label">机构简介：</span>
            <span>{{ user.entIntroduce || '-' }}</span>
          </div>
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">法人身份证正反面：</span>
          <div v-if="frCertificateUrlList && frCertificateUrlList.length <= 0">
            -
          </div>
          <img
            v-else
            @click="onShow(item)"
            :src="item"
            alt=""
            v-for="(item, index) in frCertificateUrlList"
            :key="index"
          />
        </div>
      </section>
      <section class="content">
        <div class="title">账号信息</div>
        <div class="information">
          <div class="label-item">
            <span class="label">银行开户名：</span>
            <span>{{ user.bankName || '-' }}</span>
          </div>
          <div class="label-item">
            <span class="label">开户银行：</span>
            <span>{{ user.bankType || '-' }}</span>
          </div>
          <div class="label-item">
            <span class="label">开户银行账号：</span>
            <span>{{ user.bankNumber || '-' }} </span>
          </div>
        </div>
        <!-- <div class="information">
          开户证明扫描：
          <img :src="user.bankProveUrl" alt="" v-if="user.bankProveUrl" />
          <img src="@/assets/imagess/es-sfss.png" alt="" v-else />
        </div> -->
        <div class="information">
          <span class="label">开户证明扫描：</span>
          <div v-if="bankProveUrlList && bankProveUrlList.length <= 0">-</div>
          <img
            v-else
            @click="onShow(item)"
            :src="item"
            alt=""
            v-for="(item, index) in bankProveUrlList"
            :key="index"
          />
        </div>
      </section>
      <section class="content">
        <div class="title">资质证件</div>
        <!-- <div class="information">
          营业执照：
          <img
            :src="user.businessLicenseUrl"
            alt=""
            @click="onShow(user.businessLicenseUrl)"
          />
        </div> -->
        <div class="information">
          <span class="label">营业执照：</span>
          <div
            v-if="businessLicenseUrlList && businessLicenseUrlList.length <= 0"
          >
            -
          </div>
          <img
            v-else
            @click="onShow(item)"
            :src="item"
            alt=""
            v-for="(item, index) in businessLicenseUrlList"
            :key="index"
          />
        </div>
        <div class="information">
          <span class="label">荣誉资质：</span>
          <div v-if="honorUrlList && honorUrlList.length <= 0">-</div>
          <img
            v-else
            @click="onShow(item)"
            :src="item"
            alt=""
            v-for="(item, index) in honorUrlList"
            :key="index"
          />
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">服务资质证明：</span>
          <div
            v-if="
              qualifiedServiceUrlList && qualifiedServiceUrlList.length <= 0
            "
          >
            -
          </div>
          <div
            v-for="(item, index) in qualifiedServiceUrlList"
            :key="index"
            style="padding: 0 10px"
          >
            <img
              @click="onShow(item.url)"
              v-if="
                ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG', 'JPG'].includes(
                  item.ext
                )
              "
              :src="item.url"
            />
            <el-link
              @click="handlePictureCardPreview(item)"
              :underline="false"
              v-else
              ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
            >
          </div>
          <!-- <img
            v-else
            @click="onShow(item)"
            :src="item"
            alt=""
            v-for="(item, index) in qualifiedServiceUrlList"
            :key="index"
          /> -->
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">上年度企业服务成效证明：</span>
          <div
            v-if="
              lastYearEntServerResultUrlList &&
              lastYearEntServerResultUrlList.length <= 0
            "
          >
            -
          </div>
          <div
            v-for="(item, index) in lastYearEntServerResultUrlList"
            :key="index"
            style="padding: 0 10px"
          >
            <img
              @click="onShow(item.url)"
              v-if="
                ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG', 'JPG'].includes(
                  item.ext
                )
              "
              :src="item.url"
            />
            <el-link
              :underline="false"
              @click="handlePictureCardPreview(item)"
              v-else
              ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
            >
          </div>
          <!-- <img
            v-else
            @click="onShow(item)"
            :src="item"
            alt=""
            v-for="(item, index) in lastYearEntServerResultUrlList"
            :key="index"
          /> -->
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">从业人员职称或从业资格证：</span>
          <div v-if="professionalUrlList && professionalUrlList.length <= 0">
            -
          </div>
          <div
            v-for="(item, index) in professionalUrlList"
            :key="index"
            style="padding: 0 10px"
          >
            <img
              @click="onShow(item.url)"
              v-if="
                ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG', 'JPG'].includes(
                  item.ext
                )
              "
              :src="item.url"
            />
            <el-link
              :underline="false"
              @click="handlePictureCardPreview(item)"
              v-else
              ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
            >
          </div>
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">上年度纳税证明：</span>
          <div
            v-if="lastYearEntTaxUrlList && lastYearEntTaxUrlList.length <= 0"
          >
            -
          </div>
          <div
            v-for="(item, index) in lastYearEntTaxUrlList"
            :key="index"
            style="padding: 0 10px"
          >
            <img
              @click="onShow(item.url)"
              v-if="
                ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG', 'JPG'].includes(
                  item.ext
                )
              "
              :src="item.url"
            />
            <el-link
              :underline="false"
              @click="handlePictureCardPreview(item)"
              v-else
              ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
            >
          </div>
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">社会保险参保证明 ：</span>
          <div
            v-if="socialInsuranceUrlList && socialInsuranceUrlList.length <= 0"
          >
            -
          </div>
          <div
            v-for="(item, index) in socialInsuranceUrlList"
            :key="index"
            style="padding: 0 10px"
          >
            <img
              @click="onShow(item.url)"
              v-if="
                ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG', 'JPG'].includes(
                  item.ext
                )
              "
              :src="item.url"
            />
            <el-link
              :underline="false"
              @click="handlePictureCardPreview(item)"
              v-else
              ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
            >
          </div>
        </div>
        <div class="information" v-if="message.organizationType == 2">
          <span class="label">上年度营业收入（利润表）：</span>
          <div
            v-if="
              lastYearOperatingIncomeUrlList &&
              lastYearOperatingIncomeUrlList.length <= 0
            "
          >
            -
          </div>
          <div
            v-for="(item, index) in lastYearOperatingIncomeUrlList"
            :key="index"
            style="padding: 0 10px"
          >
            <img
              @click="onShow(item.url)"
              v-if="
                ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG', 'JPG'].includes(
                  item.ext
                )
              "
              :src="item.url"
            />
            <el-link
              :underline="false"
              @click="handlePictureCardPreview(item)"
              v-else
              ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
            >
          </div>
        </div>
        <div class="information" v-if="message.organizationType == 1">
          <span class="label">入驻承诺书：</span>
          <div
            v-if="
              institutionsLetterUrlListList &&
              institutionsLetterUrlListList.length <= 0
            "
          >
            -
          </div>
          <div v-else>
            <div
              v-for="(item, index) in institutionsLetterUrlListList"
              :key="index"
              style="line-heigt: 20px; height: 20px; padding: 0 10px"
            >
              <el-link
                :underline="false"
                @click="handlePictureCardPreview(item)"
                ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
              >
            </div>
          </div>
        </div>
        <div class="information" v-else>
          <span class="label">入驻承诺书：</span>
          <div
            v-if="
              institutionsServerLetterUrlListList &&
              institutionsServerLetterUrlListList.length <= 0
            "
          >
            -
          </div>
          <div v-else>
            <div
              v-for="(item, index) in institutionsServerLetterUrlListList"
              :key="index"
              style="line-heigt: 20px; height: 20px; padding: 0 10px"
            >
              <el-link
                :underline="false"
                @click="handlePictureCardPreview(item)"
                ><i class="el-icon-tickets"></i>{{ item.name }}</el-link
              >
            </div>
          </div>
        </div>
        <div class="information">
          <el-checkbox
            :value="true"
            disabled
            style="margin-right: 5px"
          />我司承诺上诉表格中所填写的内容真实有效
        </div>
      </section>
      <section class="footer">
        <div class="title">企业信息</div>
        <Information :entInfo="newEntInfo" />
      </section>
      <section class="review" v-if="message.proveStatus == 1">
        <div>
          <el-form
            :model="message"
            ref="message"
            :rules="rules"
            label-width="80px"
            label-position="left"
          >
            <el-form-item label="审核：" prop="reviewType">
              <el-radio-group v-model="message.reviewType" @change="onchange()">
                <el-radio :label="3">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="备注："
              ref="remark"
              :prop="message.reviewType == 2 ? 'remark' : 'remark1'"
            >
              <el-input
                type="textarea"
                v-model="message.remark"
                placeholder="请输入"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <Debounce :time="5000" :isDebounce="3">
            <button
              type="button"
              class="el-button el-button--primary el-button--medium"
              @click="sendMovenSMS('message')"
            >
              <span>确 定</span>
            </button>
          </Debounce>
        </div>
      </section>
    </section>
    <section class="rightContent">
      <div class="title">审核记录</div>
      <el-timeline>
        <el-timeline-item
          :timestamp="
            item.reviewType == 3
              ? '审核通过'
              : item.reviewType == 2
              ? '审核驳回'
              : item.reviewType == 4
              ? '审核退回'
              : '提交信息'
          "
          placement="top"
          v-for="(item, index) in process"
          :key="index"
        >
          <el-card>
            <p v-if="item.reviewType != '1'">备注：{{ item.remark || '-' }}</p>
            <p>操作人：{{ item.opertator }}</p>
            <p>操作时间：{{ item.operateTime }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </section>
    <!-- <el-dialog :visible.sync="showImg" width="30%" class="showImg">
      <img width="100%" :src="exhibitImg" alt="" />
    </el-dialog> -->
    <el-image-viewer
      v-if="showImg"
      :on-close="
        () => {
          showImg = false
        }
      "
      :url-list="[exhibitImg]"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getEntOpen } from '@api/corporateInteraction/enterprise'
import {
  listRecords,
  entIntermediaryDetail2,
  entIntermediaryDetail3,
  insertRecords
} from '@api/yardIntermediary/institutionalManagement'
import Information from './components/Information.vue'
export default {
  components: { Information, ElImageViewer },
  name: 'Live',
  data() {
    return {
      frCertificateUrlList: [], // 法人公司正反面imglist
      bankProveUrlList: [], // 开户行证明
      businessLicenseUrlList: [],
      honorUrlList: [],
      qualifiedServiceUrlList: [],
      lastYearEntServerResultUrlList: [],
      professionalUrlList: [],
      lastYearEntTaxUrlList: [],
      socialInsuranceUrlList: [],
      lastYearOperatingIncomeUrlList: [],
      institutionsLetterUrlListList: [],
      institutionsServerLetterUrlListList: [],
      title: '',
      newEntInfo: {},
      dialogVisible: false,
      message: {
        creditCode: this.$route.query.creditCode,
        entName: this.$route.query.entName,
        proveStatus: this.$route.query.proveStatus, // 1审核 2查看
        organizationType: this.$route.query.organizationType, // 1 putong 2 fuwu
        reviewType: '',
        remark: ''
      },
      rules: {
        reviewType: [
          {
            required: true,
            message: '请选择审核是否通过',
            trigger: 'change'
          }
        ],
        remark: [
          {
            required: true,
            message: '请说明驳回原因',
            trigger: 'blur'
          }
        ],
        remark1: [
          {
            required: false,
            message: '请说明驳回原因',
            trigger: 'blur'
          }
        ]
      },
      fileListImg: [],
      user: {},
      process: [],
      status: '',
      showImg: false,
      exhibitImg: '',
      serviceList: []
    }
  },
  watch: {},
  computed: {},
  created() {
    this.entIntermediaryDetail()
    this.getProcessById()
    this.getEntOpen()
  },
  mounted() {},
  methods: {
    unique(arr) {
      if (!Array.isArray(arr)) {
        console.log('type error!')
        return
      }
      let list = []
      arr.forEach((item) => {
        list.push(item.split('/')[0])
      })
      list = list.sort()
      var arrry = [list[0]]
      for (var i = 1; i < list.length; i++) {
        if (list[i] !== list[i - 1]) {
          arrry.push(list[i])
        }
      }
      // 得到去重的一级数组
      let newList = []
      arrry.forEach((item) => {
        let obj = {
          name: item,
          children: []
        }
        arr.forEach((el) => {
          const first = el.split('/')[0]
          const sec = el.split('/')[1]
          if (first === item) {
            obj.children.push({ name: sec })
          }
        })
        newList.push(obj)
      })
      return newList
    },
    handlePictureCardPreview(file) {
      window.open(file.url, '_blank')
    },
    onchange() {
      if (this.message.reviewType == 3) {
        this.$refs.remark.clearValidate()
      }
    },
    // 获取详情
    entIntermediaryDetail() {
      let api =
        this.message.organizationType == 1
          ? entIntermediaryDetail2
          : entIntermediaryDetail3
      api({ creditCode: this.$route.query.creditCode }).then((res) => {
        if (res.data.code == '0000') {
          this.user = res.data.data
          this.bankProveUrlList = this.formateList1(this.user.bankProveUrl)
          this.serviceList =
            this.message.organizationType == 1
              ? this.unique(this.user.serviceNameList) || []
              : this.user.serviceNameList || []
          this.frCertificateUrlList = this.formateList1(
            this.user.frCertificateUrl
          )
          this.businessLicenseUrlList = this.formateList1(
            this.user.businessLicenseUrl
          )
          this.honorUrlList = this.formateList1(this.user.honorUrl)
          this.qualifiedServiceUrlList = this.formateList(
            this.user.qualifiedServiceUrlList
          )
          this.lastYearEntServerResultUrlList = this.formateList(
            this.user.lastYearEntServerResultUrlList
          )
          this.professionalUrlList = this.formateList(
            this.user.professionalUrlList
          )
          this.lastYearEntTaxUrlList = this.formateList(
            this.user.lastYearEntTaxUrlList
          )
          this.socialInsuranceUrlList = this.formateList(
            this.user.socialInsuranceUrlList
          )
          this.lastYearOperatingIncomeUrlList = this.formateList(
            this.user.lastYearOperatingIncomeUrlList
          )
          this.institutionsLetterUrlListList = this.formateList(
            this.user.institutionsLetterUrlList
          )
          this.institutionsServerLetterUrlListList = this.formateList(
            this.user.institutionsServerLetterUrlList
          )
        }
      })
    },
    formateList1(arr) {
      if (arr === '' || arr === null) {
        return []
      } else {
        let list = arr.split(',')
        return list
      }
    },
    formateList(arr) {
      if (arr && arr.length !== 0) {
        let list = []
        arr.forEach((item) => {
          let obj = {
            ext: item.ext,
            name: item.fileName,
            url: item.ossUrl
          }
          list.push(obj)
        })
        return list
      } else {
        return []
      }
    },
    // 获取审核记录
    getProcessById() {
      listRecords({
        creditCode: this.$route.query.creditCode,
        organizationType: this.$route.query.organizationType
      }).then((res) => {
        if (res.data.code == '0000') {
          this.process = res.data.data || []
        }
      })
    },
    /** 获取工商信息 */
    getEntOpen() {
      getEntOpen({
        creditCode: this.$route.query.creditCode,
        entName: this.$route.query.entName
      }).then((res) => {
        if (res.data.code == '0000') {
          this.newEntInfo = res.data.data || {}
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.$router.push({ name: 'intermediary' })
    },
    sendMovenSMS(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = { ...this.message }
          insertRecords(data).then((res) => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              // this.getProcessById()
              // this.entIntermediaryDetail()
              this.$router.push({ name: 'auditList' })
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /** 打开弹性 */
    onShow(item) {
      this.exhibitImg = item
      this.showImg = true
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.container {
  width: 100%;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  /deep/ .el-link--inner {
    display: inline-block;
    padding: 6px 10px;
    height: 30px;
    border-radius: 4px;
    background-color: #f7f7f7;
    cursor: pointer;
    margin-right: 20px;
    i {
      font-size: 15px;
      color: #3399ff;
      margin-right: 10px;
    }
  }
  & > .leftContent {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    > .header {
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      & > .information {
        padding: 0 24px 16px;
        margin-top: 16px;
        display: flex;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        .label {
          color: black;
          min-width: 70px;
        }
        img {
          cursor: pointer;
          width: 150px;
          height: 150px;
          margin-right: 15px;
        }
        .label-item {
          width: 33.3% !important;
        }
        > div {
          // width: 450px;
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
      & > .service {
        > div {
          width: 100%;
          display: flex;
          > div {
            > div {
              margin-bottom: 10px;
              > span {
                margin-right: 10px;
              }
            }
          }
        }
        .serve_item {
          display: flex;
          flex-wrap: wrap;
          flex: 1;
        }
        .service-type-box {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 10px;
          .first-type {
            min-width: 70px;
          }
          .sec-type {
            flex: 1;
            span {
              margin-right: 10px;
              margin-bottom: 10px;
              display: inline-block;
            }
          }
        }
      }
    }
    > .content {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      & > .information {
        padding: 0 24px 16px;
        margin-top: 16px;
        display: flex;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        .label-item {
          width: 33.3%;
        }
        .label {
          color: black;
          min-width: 70px;
        }
        img {
          cursor: pointer;
          width: 150px;
          height: 150px;
          margin-right: 15px;
        }
        > div {
          // width: 400px;
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
      > .text {
        padding: 0 21px;
        font-size: 14px;
        line-height: 25px;
        color: rgba(0, 0, 0, 0.5);
        > p {
          color: rgba(0, 0, 0, 0.85);
        }
      }
      > .ImgContent {
        padding: 0 21px 30px;
        display: flex;
        margin-top: 30px;
        > div {
          width: 167px;
          height: 200px;
          line-height: 200px;
          margin-right: 20px;
          > img {
            max-height: 200px;
            vertical-align: middle;
            width: inherit;
            cursor: pointer;
            border-radius: 3px;
          }
        }
      }
    }
    > .footer {
      margin-top: 16px;
      background: white;
      > .title {
        padding: 16px 21px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      > .block {
        width: 60%;
        margin-top: 30px;
      }
    }
    > .review {
      margin-top: 16px;
      padding: 24px 300px;
      background: white;
      /deep/ .el-textarea__inner {
        min-height: 150px !important;
      }
      .dialog-footer {
        display: flex;
        justify-content: center;
      }
    }
  }
  & > .rightContent {
    margin-left: 20px;
    width: 400px;
    background: white;
    height: 100%;
    overflow-y: auto;
    > .title {
      padding: 15px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    > .text {
      color: rgba(102, 102, 102, 100);
      font-size: 14px;
    }
    /deep/ .el-card {
      border: none;
      box-shadow: none;
      // background-color: rgba(0, 0, 0, 0.02);
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    /deep/ .el-timeline {
      padding: 0 15px;
      background: white;
    }
    /deep/ .el-timeline-item__node {
      background-color: rgba(24, 144, 255, 1);
    }
    /deep/ .el-timeline-item__tail {
      height: 88%;
      margin-top: 15px;
      border-left: 2px solid rgba(24, 144, 255, 1);
    }
  }
}
</style>
